import React from 'react'
import type { ExperienceOfferPageState } from './experienceOfferPageStateReducer'
import { INITIAL_EXPERIENCE_PAGE_STATE } from './experienceOfferPageStateReducer'

const ExperienceOfferPageStateContext = React.createContext<ExperienceOfferPageState>(INITIAL_EXPERIENCE_PAGE_STATE)

export default ExperienceOfferPageStateContext
